// src/Api/Cotisation/Cotisation.js
import { apiGet } from '../standardApi';

// Récupérer les données brutes de l'API
export async function apiGetCotisation() {
  try {
    return await apiGet(`/Accounting/GetCotisations`, 'application/json');
  } catch (error) {
    console.error("Erreur lors de l'appel API : ", error);
    throw new Error("Échec de la récupération des cotisations.");
  }
}

// Vérification des cotisations et définition de l'affichage
const MODAL_SHOWN_COTISATION = 'cotisationModalShown';

// Vérification des cotisations et définition de l'affichage
const getCotisationDisplayInfo = (cotisations) => {
  if (!cotisations || parseInt(cotisations.codeerreur) !== 0) {
    return { showModal: false, showMenu: false };
  }

  const totalCotisation = cotisations.tdbCotisationTotale || {};
  const nbQuittances = parseInt(totalCotisation.nbQuittances) || 0;
  const montantAPayer = parseFloat(totalCotisation.montantApayer).toFixed(2) || 0;
  const hasPeriodes = totalCotisation.tdbCotisationPeriodes;

  // Récupération de typepaiement
  const typepaiement = totalCotisation.typepaie?.typepaie1 || false;

  // Vérifier si le modal a déjà été affiché dans cette session
  const modalAlreadyShown = sessionStorage.getItem(MODAL_SHOWN_COTISATION);

  // MAJ de la condition pour afficher le modal selon I : impayé de prelevement
  const shouldShowModal = hasPeriodes && montantAPayer > 0 && !modalAlreadyShown && typepaiement === "I";

  // marque comme déjà affiché
  if (shouldShowModal) {
    sessionStorage.setItem(MODAL_SHOWN_COTISATION, 'true');
  }

  return {
    showModal: shouldShowModal,
    showMenu: nbQuittances > 0
  };
};

// Récupère les infos pour afficher le modal et le menu "Cotisations"
export async function apiGetCotisationDisplayInfo() {
  try {
    const cotisations = await apiGetCotisation();
    return getCotisationDisplayInfo(cotisations);
  } catch (error) {
    console.error("Erreur lors de la récupération des données pour le modal et le menu :", error);
    return { showModal: false, showMenu: false };
  }
}
